import React, { useRef, useEffect, forwardRef } from "react";
import { gsap } from "gsap";
import "./SlideVideos.css";
import EpisodeCard from "../VideoCard/VideoCard";
import { useSelector } from "react-redux";
import { selectApp } from "../../app/appSlice";

const SlideVideosRow = forwardRef(({ data, hidden }, ref) => {
  const seriesListRef = useRef(null);
  const episodeRefs = useRef([]); // Array of refs for each episode in sequential order
  const { lastFocusedElement } = useSelector(selectApp);

  // Key navigation listener for episode cards
  useEffect(() => {
    // If return from watch page, scroll to last point
    if (lastFocusedElement && seriesListRef.current) {
      const isActiveRow = seriesListRef.current.contains(
        document.getElementById(lastFocusedElement.id)
      );

      if (isActiveRow) {
        gsap.set(seriesListRef.current, { x: lastFocusedElement.scrollLeft });
      }
    }
  }, [lastFocusedElement]);

  return (
    <div className="slide-category-row" ref={ref} hidden={hidden}>
      <div className="series-list-wrapper">
        <div className={`series-list d-flex`} ref={seriesListRef}>
          {data.series[0].episodes.map((episode) => (
            <div key={episode.episode_id} className={`series series-slide`}>
              <div className={`${"d-flex justify-content-center flex-wrap"}`}>
                <EpisodeCard
                  key={episode.episode_id}
                  episode={episode}
                  series={episode}
                  ref={(el) => el && episodeRefs.current.push(el)} // Push each EpisodeCard ref in order
                />
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
});

export default SlideVideosRow;
